import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { mergeEntity, mergeEntities } from '@utils/object.js'

export const initialState = {}

const defaultAttributes = {}

export const photo = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_PHOTO, (state, action) => receivePhoto(state, action))
    .addCase(ActionTypes.RECEIVE_PHOTOS, (state, action) => receivePhotos(state, action))
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(ActionTypes.PHOTO_DELETE_SUCCESS, (state, action) => removePhoto(state, action))
})

export default photo

function receivePhoto(state, action) {
  const { payload: photo } = action
  return mergeEntity(state, photo, defaultAttributes)
}
function receivePhotos(state, action) {
  const { payload: photos } = action
  return mergeEntities(state, photos, defaultAttributes)
}

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('photo')) {
    const { photo } = payload
    state = mergeEntity(state, photo, defaultAttributes)
  }
  if (payload.hasOwnProperty('photos')) {
    const { photos } = payload
    state = mergeEntities(state, photos, defaultAttributes)
  }
  return state
}

function removePhoto(state, action) {
  const { payload: id } = action
  delete state[id]
}
